import { AppPage } from "@/features/app-page";
import { ToolHashType } from "@/gql/__generated__/graphql";
import { createFileRoute } from "@tanstack/react-router";

function PublicAppPage() {
  const { publicAppHash } = Route.useParams();

  return <AppPage appHash={publicAppHash} hashType={ToolHashType.Public} />;
}

export const Route = createFileRoute("/_app-layout/public/$publicAppHash")({
  component: PublicAppPage
});
